import { Component, Inject, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../../../core/api.service';
import { AuthService } from '../../../../core/auth.service';
import { Bill, Table, Command } from '../../../../core/models';

export interface CancelCommandModalData {
  command: Command;
}
export type CancelCommandModalReturn = boolean;

@Component({
  templateUrl: 'cancel-command.component.html'
})
export class CancelCommandModalComponent implements OnDestroy {

  private readonly destroyed: Subject<void> = new Subject();

  private _loading: boolean;
  public get loading(): boolean {
    return this._loading;
  }
  public set loading(loading: boolean) {
    this._loading = loading;
    this.ref.disableClose = loading;
  }

  public form = new FormGroup({
    amount: new FormControl(1, [Validators.min(1), Validators.max(this.data.command.cancelable)])
  })

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private ref: MatDialogRef<CancelCommandModalComponent, CancelCommandModalReturn>,
    @Inject(MAT_DIALOG_DATA) public data: CancelCommandModalData
  ) { }

  public ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  public cancel(): void {
    this.ref.close(false);
  }

  public submit(): void {
    this.loading = true;

    this.api.cancelCommand(this.data.command.idpvComandas, this.form.value.amount, this.auth.user.idpvUsuarios,).subscribe({
      next: () => {
        this.ref.close(true);
        this.loading = false;
      },
      error: error => {
        console.error(error);
        this.loading = false;
      }
    });
  }
}
